// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/bell-02.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*상단바*/
header{
    height: 72px;
    border-bottom: 1px solid #f8f8f8;
    opacity: 0.9;
    background: #FFF;
    padding: 20px 35px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
}
/*로고*/
header h1{
    width: 180px;
    margin-right: 48px;
}
header h1 a{display: block; position: relative; top: 6px;}

/*시간*/
header .now{
    display: flex;
    padding: 6px 14px 6px 10px;
    align-items: center;
    gap: 14px;
    border-radius: 5px;
    background: #F4F4F4;
    margin-right: 26px;
}
header .now span{
    color: #222;
    font-size: 18px;
    letter-spacing: -0.72px;
    position: relative;
    top: -2px;
}
/*신규 고객 추가 버튼*/
header .add_customer{
    display: inline-flex;
    padding: 8px 14px;
    align-items: center;
    gap: 20px;
    border-radius: 22px;
    border: 1px solid #51D7DF;
}
header .add_customer span{
    color: #51D7DF;
    font-size: 16px;
    font-weight: 700;
    line-height: 150%; /* 24px */
    letter-spacing: -0.64px;
}
/* 버튼 활성화시-hover, click*/
header .add_customer:hover, header .add_customer.on{
    background: #51D7DF;
}
header .add_customer:hover span, header .add_customer.on span{
    color: #fff;
}

header .add_customer:hover path, header .add_customer.on path{fill: #fff;}
header .right{margin-left: auto;display: flex;}
/*검색버튼*/
header .search_bar{
    width: 180px;
    display: flex;
    padding: 8px 8px 8px 16px;
    align-items: center;
    border-radius: 99px;
    background: #F5F5F5;
    margin-right: 38px;
}
header .search_bar input{width: 154px;}

/*알람버튼*/
header .alarm{
    display: block;
    width: 30px;
    height: 30px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    position: relative;
    top:4px;
}
/*알람뱃지*/
header .alarm span{
    display: block;
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background: #51D7DF;
    color: #fff;
    font-size: 9px;
    text-align: center;
    line-height: 14px;
    position: absolute;
    top:-3px;
    right: -2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Header.css"],"names":[],"mappings":"AAAA,MAAM;AACN;IACI,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IAEf,sBAAsB;IAG9B,aAAa;IAGL,mBAAmB;AAC/B;AACA,KAAK;AACL;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA,YAAY,cAAc,EAAE,kBAAkB,EAAE,QAAQ,CAAC;;AAEzD,KAAK;AACL;IAGI,aAAa;IACb,0BAA0B;IAGlB,mBAAmB;IAC3B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;AACb;AACA,cAAc;AACd;IAGI,oBAAoB;IACpB,iBAAiB;IAGT,mBAAmB;IAC3B,SAAS;IACT,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,uBAAuB;AAC3B;AACA,wBAAwB;AACxB;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;;AAEA,8DAA8D,UAAU,CAAC;AACzE,cAAc,iBAAiB,CAA2C,aAAa,CAAC;AACxF,OAAO;AACP;IACI,YAAY;IAGZ,aAAa;IACb,yBAAyB;IAGjB,mBAAmB;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;AACA,yBAAyB,YAAY,CAAC;;AAEtC,OAAO;AACP;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mDAAmC;IACnC,sBAAsB;IACtB,kBAAkB;IAClB,OAAO;AACX;AACA,OAAO;AACP;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf","sourcesContent":["/*상단바*/\nheader{\n    height: 72px;\n    border-bottom: 1px solid #f8f8f8;\n    opacity: 0.9;\n    background: #FFF;\n    padding: 20px 35px 20px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n/*로고*/\nheader h1{\n    width: 180px;\n    margin-right: 48px;\n}\nheader h1 a{display: block; position: relative; top: 6px;}\n\n/*시간*/\nheader .now{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 6px 14px 6px 10px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 14px;\n    border-radius: 5px;\n    background: #F4F4F4;\n    margin-right: 26px;\n}\nheader .now span{\n    color: #222;\n    font-size: 18px;\n    letter-spacing: -0.72px;\n    position: relative;\n    top: -2px;\n}\n/*신규 고객 추가 버튼*/\nheader .add_customer{\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    padding: 8px 14px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 20px;\n    border-radius: 22px;\n    border: 1px solid #51D7DF;\n}\nheader .add_customer span{\n    color: #51D7DF;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 150%; /* 24px */\n    letter-spacing: -0.64px;\n}\n/* 버튼 활성화시-hover, click*/\nheader .add_customer:hover, header .add_customer.on{\n    background: #51D7DF;\n}\nheader .add_customer:hover span, header .add_customer.on span{\n    color: #fff;\n}\n\nheader .add_customer:hover path, header .add_customer.on path{fill: #fff;}\nheader .right{margin-left: auto;display: -webkit-box;display: -ms-flexbox;display: flex;}\n/*검색버튼*/\nheader .search_bar{\n    width: 180px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 8px 8px 8px 16px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 99px;\n    background: #F5F5F5;\n    margin-right: 38px;\n}\nheader .search_bar input{width: 154px;}\n\n/*알람버튼*/\nheader .alarm{\n    display: block;\n    width: 30px;\n    height: 30px;\n    background: url(../img/bell-02.png);\n    background-size: cover;\n    position: relative;\n    top:4px;\n}\n/*알람뱃지*/\nheader .alarm span{\n    display: block;\n    width: 14px;\n    height: 14px;\n    border-radius: 7px;\n    background: #51D7DF;\n    color: #fff;\n    font-size: 9px;\n    text-align: center;\n    line-height: 14px;\n    position: absolute;\n    top:-3px;\n    right: -2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
